"use client";

import { Toaster as Sonner, ToasterProps } from "sonner";
import { CheckCircle2, XCircle, AlertTriangle, Info, LoaderCircle } from "lucide-react";

// Consistent iconography: use the same lucide set as the rest of the app instead of
// Sonner's built-in SVGs. Colors are applied by src/styles/toast.css per toast type.
const TOAST_ICONS = {
  success: <CheckCircle2 size={17} strokeWidth={2.25} />,
  error: <XCircle size={17} strokeWidth={2.25} />,
  warning: <AlertTriangle size={17} strokeWidth={2.25} />,
  info: <Info size={17} strokeWidth={2.25} />,
  loading: <LoaderCircle size={17} strokeWidth={2.25} className="mtt-toast-spin" />,
};

// Branded, theme-aware toaster. Visual styling lives in src/styles/toast.css (token-driven,
// so it adapts to light/dark automatically); this component sets behaviour + the class hooks.
const Toaster = ({ ...props }: ToasterProps) => {
  return (
    <Sonner
      className="mtt-toaster"
      position="top-center"
      gap={10}
      offset={24}
      duration={4000}
      icons={TOAST_ICONS}
      closeButton
      toastOptions={{
        classNames: {
          toast: "mtt-toast",
          title: "mtt-toast-title",
          description: "mtt-toast-desc",
          actionButton: "mtt-toast-action",
          cancelButton: "mtt-toast-cancel",
          closeButton: "mtt-toast-close",
        },
      }}
      style={
        {
          "--normal-bg": "var(--surface)",
          "--normal-text": "var(--text-primary)",
          "--normal-border": "var(--border)",
        } as React.CSSProperties
      }
      {...props}
    />
  );
};

export { Toaster };
